module.exports = __webpack_public_path__ + "1fa18f1a135a753c1a66527a9c68e9f6.jpeg";